<template>
    <div>
        <div class="share_btns">
            <button class="btn btn-primary" v-on:click="print"><i class="fa fa-print"></i></button>
            <button class="btn btn-success" v-on:click="emailTo"><i class="fa fa-envelope"></i></button>
            <button class="btn btn-danger" v-on:click="saveToFav"><i class="fa fa-heart"></i></button>
        </div>
        <!-- Email Modal -->
        <div id="emailModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Email</h4>
                        <button type="button" class="close text-danger" @click="modalclose" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body table-responsive">
                        <form name="thisForm" method="post" @submit.prevent="validateBeforeSubmit">
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>
                                            <label>Recipient Name</label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="recipient_name" name="recipient_name" class="form-control">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Recipient's Email <font color="red">*</font></label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="recipient" v-validate="'required|email'"
                                                :class="{'form-control': true, 'is-invalid': errors.has('recipient') }"
                                                name="recipient" class="form-control">
                                            <small class="form-text text-danger" v-show="errors.has('recipient')">Please
                                                enter valid recipient.</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Your Name</label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="name" name="name" class="form-control">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Your Email <font color="red">*</font></label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="email" v-validate="'required|email'"
                                                :class="{'form-control': true, 'is-invalid': errors.has('email') }"
                                                name="email" class="form-control">
                                            <small class="form-text text-danger" v-show="errors.has('email')">Please
                                                enter valid email.</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td valign="top">
                                            <label>Comment</label>
                                        </td>
                                        <td>
                                            <textarea name="comment" class="form-control" v-model="comment"></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="text-align: center;">
                                            <button d-inline-block class="g-recaptcha ms-2 btn btn-success" :sitekey="recaptchaSitekey" data-callback='onSubmit' data-action='submit' data-size="invisible" variant="btn btn-success">Send</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        data: function () {
            return {
                env: process.env.MIX_THEME,
                recipient_name: '',
                recipient: '',
                name: '',
                email: '',
                comment: '',
                gRecaptchaResponse: null,
            }
        },
        methods: {
            // onVerify(response) {
            //     this.gRecaptchaResponse = response;
            // },
            onExpiry(){
                this.$refs.recaptcha.reset();
            },
            saveToFav() {
                console.log('Save To Fav');
                this.$swal.fire({
                    title: '<strong>Press <u>ctrl + D</u></strong>',
                    type: 'info',
                    html: 'You can add this page to your , ' +
                        'Bookmarks by pressing CTRL +D on your keyword.',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
                    cancelButtonAriaLabel: 'Thumbs down'
                })
            },
            print() {
                window.print();
            },
            emailTo() {
                $('#emailModal').modal('show');
            },
            modalclose() {
                $('#emailModal').modal('hide');
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let that = this;
                        grecaptcha.ready(function() {
                            grecaptcha.execute(that.recaptchaSitekey, {action: 'submit'}).then(function(token) {
                                axios.post(that.url + '/email', {
                                    recipient_name: that.recipient_name,
                                    recipient: that.recipient,
                                    name: that.name,
                                    email: that.email,
                                    comment: that.comment,
                                    url: window.location.href,
                                    g_recaptcha_response: token,
                                    ga4_session_id: window.ga4_session_id,
                                }).then(function (response) {
                                    Vue.$toast.open({
                                        message: response.data,
                                        type: "success",
                                        duration: 5000,
                                        dismissible: true
                                    })
                                    that.$nextTick(() => {
                                        that.$refs.modal.hide()
                                    })
                                    that.recipient_name = null;
                                    that.recipient = null;
                                    that.name = null;
                                    that.email = null;
                                    that.comment = null;
                                    $('#emailModal').modal('hide');
                                }).catch(function (error) {
                                    console.log(error);
                                });
                                return false;
                            });
                        });
                    }
                });
            }
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                return window.location.href;
            },
            segment: function () {
                return window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
            },
            recaptchaSitekey: function() {
                return process.env.MIX_GOOGLE_RECAPTCHA_KEY;
            }
        },
    }

</script>
